import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import React from "react";

export const FormDialog = ({ open, onClose, onSubmit, title, children, actions, sx = {} }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: { borderRadius: "10px", ...sx },
          ...(onSubmit
            ? {
                component: "form",
                onSubmit: async (e) => {
                  e.preventDefault();
                  await onSubmit();
                },
              }
            : {}),
        },
      }}
    >
      {title && <DialogTitle>{title}</DialogTitle>}
      <DialogContent sx={{ pb: 0 }}>{children}</DialogContent>
      {actions && <DialogActions sx={{ mb: 2, mr: 2 }}>{actions}</DialogActions>}
    </Dialog>
  );
};
